import client from './client';
import { FTPAccount } from '../types';

export const ftpAccountsApi = {
  list: (eventId: string) =>
    client.get<FTPAccount[]>(`/events/${eventId}/ftp-accounts`).then((r) => r.data),

  create: (eventId: string, data: { photographerName: string }) =>
    client.post<FTPAccount>(`/events/${eventId}/ftp-accounts`, data).then((r) => r.data),

  delete: (eventId: string, accountId: string) =>
    client.delete(`/events/${eventId}/ftp-accounts/${accountId}`).then((r) => r.data),
};
